<template>
  <div class="list-item">
    <div class="icon-wrapper">
      <v-icon size="30px">mdi-account-outline</v-icon>
    </div>
    <v-list-item-content>
      <div class="item-right">
        <div class="description">
          <div class="d-flex" :class="{ 'flex-column': isMobile }">
            <span class="font-weight-bold mb-2">{{ user | fullName }}</span>
            <span class="mx-1" v-if="!isMobile"> | </span>
            <span>{{ user.email }}</span>
          </div>
          <span class="secondary-text mr-2">
            {{ roles }}
          </span>
        </div>
        <div class="d-flex flex-column align-end">
          <div class="d-flex">
            <ResendInvitation
              :user="user"
              v-if="showInviteButton(user.detailedStatus)"
              :title="getInviteButtonText(user.detailedStatus)"
            />
            <Chip
              :color="getColorByStatus(user.detailedStatus)"
              class="chip--status my-2"
              shrink
            >
              {{ user.detailedStatus | upperCase }}
            </Chip>
          </div>
          <span class="secondary-text">
            {{ userActivity }}
          </span>
        </div>
      </div>
    </v-list-item-content>
  </div>
</template>

<script>
import { getColorByStatus } from "@/utils/users";
import Chip from "@/components/common/Chip";
import { USER_STATUSES } from "@/constants/users";
import { BASE_DATE_FORMAT } from "@/constants/common.js";
import { formatDate } from "@/utils/time";
import { getRolesToDisplay } from "@/utils/users";
import ResendInvitation from "@/views/settings/Users/actions/ResendInvitation";

const { INCOMPLETE, INACTIVE, ACTIVE, INVITED, INVITE_EXPIRED } = USER_STATUSES;

export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  components: {
    Chip,
    ResendInvitation
  },
  data() {
    return {};
  },
  computed: {
    roles() {
      return getRolesToDisplay(this.user);
    },
    userActivity() {
      const { lastSessionDate, inviteDate, detailedStatus } = this.user;
      switch (detailedStatus.toLowerCase()) {
        case ACTIVE:
        case INACTIVE:
        case INCOMPLETE:
          return (
            lastSessionDate &&
            `Last session ${this.getFormattedDate(lastSessionDate)}`
          );
        case INVITED:
        case INVITE_EXPIRED:
          return inviteDate && `Invited ${this.getFormattedDate(inviteDate)}`;
        default:
          return "";
      }
    }
  },
  methods: {
    getFormattedDate(date) {
      return formatDate({
        date,
        endFormat: BASE_DATE_FORMAT
      });
    },
    showInviteButton(status) {
      return (
        status === INVITED || status === INVITE_EXPIRED || status === INACTIVE
      );
    },
    getInviteButtonText(status) {
      if (status === INVITED || status === INVITE_EXPIRED) {
        return "Resend";
      }
      return "Invite";
    },
    getColorByStatus
  }
};
</script>
<style lang="scss">
.list-item {
  .icon-wrapper {
    display: flex;
    justify-content: center;
    width: 62px;
    height: 60px;
    background-color: rgba(199, 39, 255, 0.1);
    padding: 6px 8px;
    border-radius: 64px;
    margin-right: 14px;

    i {
      color: $black;
    }
  }
  .description {
    min-height: 40px !important;
  }
}
</style>
